import { Injectable } from '@angular/core';
import { EmojiService, categories } from '@ctrl/ngx-emoji-mart/ngx-emoji';

export interface RandomEmojiOptions {
  excludeCategories?: string[];
}

@Injectable({ providedIn: 'root' })
export class IconPickerService {
  constructor(private readonly emojiService: EmojiService) {}

  selectRandom(options?: RandomEmojiOptions): string | null {
    const excludeCategories = options?.excludeCategories ? new Set(options.excludeCategories) : undefined;

    let emojis = this.emojiService.emojis;

    if (excludeCategories) {
      const allowedUnified = new Set(
        categories.filter((c) => !excludeCategories.has(c.id)).flatMap((c) => c.emojis ?? []),
      );
      emojis = emojis.filter((e) => e.unified && allowedUnified.has(e.unified) && e.native);
    } else {
      emojis = emojis.filter((e) => e.native);
    }

    if (emojis.length === 0) {
      return null;
    }

    const randomIndex = Math.floor(Math.random() * emojis.length);
    return emojis[randomIndex].native!;
  }
}
